import React, { useState, useEffect, useRef, useCallback } from 'react';

import { Button } from 'react-bootstrap';
import Sound from 'react-sound';
import { s3base } from "api.js";

import Recorder from "components/Recorder/Recorder";
import MicWaveform from 'components/Question/Speaking/MicWaveform';
import stopImage from "assets/images/stop recording.png";
import ReusableRecorder from 'components/Recorder/ReusableRecorder';
import { isIOSDevice } from 'util/deviceDetection';
import useBeep from 'components/BeepSound';
import Beep from 'Beep.js';

const WAITING = 35;
const LIMIT = 35;

export default function FunctionBox(props) {

	const [waiting, setWaiting] = useState(true);
	const [beep, setBeep] = useState(false);
	const [recording, setRecording] = useState(false);
	const [trans, setTrans] = useState("");
	const [processComplete, setProcessComplete] = useState(false);
	const [file, setFile] = useState(null);
	const [duration, setDuration] = useState(0);
	const [blobUrl, setBlobUrl] = useState("");
	const recorderRef = useRef(null);
	const stopRecordingHandled = useRef(false);
	const { playBeep } = useBeep({ frequency: 800, duration: 300, volume: 0.3 });

	const updateWaitingStatus = (status) => {
		setWaiting(status);
		setBeep(true);
	}

	// Start recording immediately — called the moment the beep begins playing
	const startRecordingNow = useCallback(() => {
		if (recorderRef.current) {
			recorderRef.current.startRecording();
		}
		setRecording(true);
	}, []);

	// Recording already started when beep began — just clear beep status
	const beepComplete = () => {
		setBeep(false);
	}

	const updateRecordingStatus = (status) => {
		setRecording(status);
	}


	const handleRecordingComplete = useCallback((recordingData) => {
		console.log('FunctionBox: handleRecordingComplete called with:', recordingData);
		const { blob, url, transcript, duration: recordDuration, file } = recordingData;
		
		setFile(file);
		setDuration(recordDuration || 0);
		setBlobUrl(url || "");
		setTrans(transcript || "");
		console.log(props);
		
		if (props.submitReadySet && (!isIOSDevice() || props.stopRecording)) {
			console.log('FunctionBox: Calling submitReadySet with data');
			props.submitReadySet({
				file,
				duration: recordDuration || 0,
				blobUrl: url || "",
				transcript: transcript || ""
			});
		}
	}, [props]);
	
	const handlePlayBeep = useCallback(() => {
		playBeep({
			onStart: () => {
				setBeep(true);
				// Start recording immediately when beep begins so no audio is missed
				startRecordingNow();
			},
			onComplete: () => {
				// Recording already running — just clear beep status
				setBeep(false);
			},
			onError: (error) => {
				console.error('Beep failed:', error);
				setBeep(false);
			}
		});
  	}, [playBeep, startRecordingNow]);

	useEffect(() => {
		if (isIOSDevice() && beep) {
			handlePlayBeep();
		}
	}, [beep, playBeep, isIOSDevice]);

	// Non-iOS: start recording immediately when beep begins playing
	useEffect(() => {
		if (!isIOSDevice() && beep) {
			startRecordingNow();
		}
	}, [beep, startRecordingNow]);

	/**
	 * Skip waiting timer.
	 */
	const skip = useCallback(() => {
		setWaiting(false);
		setBeep(true);
	},[])

	/**
	 * Stop Recording.
	 */
	const stop = useCallback(() => {
		updateRecordingStatus(false);
		if (recorderRef.current) {
			recorderRef.current.stopRecording();
		}
	},[recording])



	/**
	 * stopRecording from parent components
	 * For mocks.
	 */
	useEffect(() => {
		if (props.stopRecording === true && !stopRecordingHandled.current) {
			stopRecordingHandled.current = true;
			console.log('FunctionBox: stopRecording detected, recording:', recording, 'waiting:', waiting);
			if (recording) {
				console.log('FunctionBox: Currently recording, calling stop()');
				stop();
			} else {
				console.log('FunctionBox: Not recording, creating empty submission');
				// Create empty recording data and submit directly
				setWaiting(false);
				setBeep(false);
				const emptyBlob = new Blob([], { type: 'audio/webm' });
				const emptyFile = new File([emptyBlob], "noname.mp3", { type: emptyBlob.type });
				
				if (props.submitReadySet) {
					props.submitReadySet({
						file: emptyFile,
						duration: 0,
						blobUrl: "",
						transcript: ""
					});
				} else {
					console.error('FunctionBox: submitReadySet prop is not available for empty submission');
				}
			}
		} else if (props.stopRecording === false) {
			// Reset the flag when stopRecording becomes false
			stopRecordingHandled.current = false;
		}
	}, [props.stopRecording, stop, recording, waiting]);


	return (
		<>
			{/* {recording && (
				<Recorder
					ref={recorderRef}
					onRecordingComplete={handleRecordingComplete}
					onRecordingStop={() => updateRecordingStatus(false)}
					maxDuration={LIMIT * 1000}
					enableSpeechRecognition={true}
					className="d-none"
				/>
			)} */}
			 <ReusableRecorder
					ref={recorderRef}
					onRecordingComplete={handleRecordingComplete}
					onRecordingStop={() => updateRecordingStatus(false)}
					maxDuration={LIMIT * 1000}
					enableSpeechRecognition={true}
					fileName={"noname.mp3"}
				  />
			{/* audio-box */}
			<div className="audio-box border-0" style={{maxWidth: '340px'}}>

				{/*
					This section is hidden according to the ALFA design.	
				<h4>Recorded Answer</h4>
				<p><strong>Current status:</strong></p> */}
				<div>
					{waiting &&
						<Waiting
							waiting={updateWaitingStatus}
							pauseWaiting={props.pauseWaiting}
						/>
					}

					{!isIOSDevice() && beep &&
						<Sound
							// url={`${s3base}/ptedata/ptemedia/beep.mp3`}
							url={Beep}
							playStatus={Sound.status.PLAYING}
							onFinishedPlaying={() => beepComplete()}
							onError={()=> beepComplete()}
						/>
					}

					{recording &&
						<span>Recording</span>
					}

					{!waiting && !beep && !recording &&
						<span>Recording Stopped.</span>
					}
				</div>

				{!props.testMode && waiting &&
					<div className='stop-btn'>
						<Button variant="success" onClick={() => skip()} size="sm">Skip</Button>
					</div>
				}

				{recording &&
					<>
						{!props.testMode &&
							<div className='stop-btn'>
								<Button variant="success" onClick={() => stop()} size="sm">Stop</Button>
							</div>
						}

						<RecordingProgress
							stop={stop}
						/>
					</>
				}

				<div className="audo-line">
					<span className="progress-bar-fill-Read intro"></span>
				</div>
			</div>
		</>
	);
}


/**
 * Waiting.
 */
function Waiting(props) {
	const [seconds, setSeconds] = useState(WAITING);
	const [timerId, setTimerId] = useState(null);
	const [init, setInit] = useState(false);

	const watingTimer = (isSubscribed) => {
		const id = setInterval(() => {
			if (isSubscribed) {
				setSeconds(seconds => (seconds - 1));
			}
		}, 1000);
		setTimerId(id);
	};


	useEffect(() => {
		const { pauseWaiting } = props;
		if (pauseWaiting) {
			clearInterval(timerId);
		} else if (init) {
			watingTimer(true);
		}
	}, [props.pauseWaiting]);


	useEffect(() => {
		let isSubscribed = true;

		watingTimer(isSubscribed);

		// set init value after 1s.
		setTimeout(() => {
			setInit(true);
		}, 1000);

		// component will unmount.
		return (() => {
			clearInterval(timerId);
			isSubscribed = false;
		});
	}, []);


	useEffect(() => {
		if (seconds === 0) {
			props.waiting(false);
			clearInterval(timerId);
		}
	}, [seconds]);


	return (
		<div className='d-flex justify-content-center align-items-center gap-2 my-2'>
		    <div className="recording-circle" id="countdown">{seconds}</div>
			Recording in {seconds} seconds
		</div>
	);
}


/**
 * Recording Progress.
 */
function RecordingProgress(props) {

	const [seconds, setSeconds] = useState(0);
	const [timerId, setTimerId] = useState(null);

	useEffect(() => {
		let isSubscribed = true;

		const id = setInterval(() => {
			if (isSubscribed) {
				setSeconds(seconds => (seconds + 1));
			}
		}, 1000);
		setTimerId(id);

		// below will execute when component is about to  unmount.
		return (() => {
			isSubscribed = false;
			clearInterval(timerId); // precautionary. just to avoid errors and warnings.
		});
	}, []);


	useEffect(() => {
		if (seconds >= LIMIT) {
			clearInterval(timerId);
			props.stop(); // This will cause component unmount.
		}
	}, [seconds]);


	const recordingTime = LIMIT - seconds;

	return (
		// <Progress color="info" value={(seconds*3)} />
		<div
			className="d-flex justify-content-start align-items-center gap-3"
			style={{ minHeight: "60px" }}
		>
			<img
				src={stopImage}
				alt="Stop Recording"
				style={{
					height: "65px",
					width: "65px",
					objectFit: "contain",
					display: "block",
				}}
			/>

			<div
				className="d-flex align-items-center flex-grow-1 mb-4"
				style={{ height: "40px" }}
			>
				<MicWaveform progressValue={seconds * 3} mockColor={"#0081A4"} time={recordingTime} />
			</div>
		</div>
	);
}
